'use strict';

angular.module('study.documents')
    .component('documentsMain', {
        templateUrl: 'modules/documents/main.html',
        controller: 'DocumentsController',
    });
